import React, { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const formatDate = (dateStr) => {
  if (!dateStr) return '';

  const d = new Date(dateStr);

  const y = d.getFullYear();
  const m = ('0' + (d.getMonth() + 1)).slice(-2);
  const day = ('0' + d.getDate()).slice(-2);

  return `${y}/${m}/${day}`;
};

const ReservationByLocation = ({ location }) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!location) {
      setResults([]);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError('');

      try {
        const res = await fetch(
          `${API_BASE_URL}/search_by_location.php?location=${encodeURIComponent(location)}`
        );

        if (!res.ok) {
          throw new Error('サーバーエラー');
        }

        const json = await res.json();

        setResults(json);

      } catch (e) {
        console.error(e);

        setError('データ取得に失敗しました');
        setResults([]);

      } finally {
        setLoading(false);
      }
    };

    fetchData();

  }, [location]);

  return (
    <div>
      <h3 style={{ marginBottom: '10px' }}>
        {location}の予約状況
      </h3>

      {loading && (
        <p>読み込み中...</p>
      )}

      {!loading && error ? (
        <p style={{ color: 'red' }}>
          {error}
        </p>
      ) : (
        <>
          {!loading && results.length > 0 && (
            <table
              border="1"
              cellPadding="5"
              style={{
                marginTop: '10px',
                borderCollapse: 'collapse',
                width: '100%',
              }}
            >
              <thead>
                <tr>
                  <th>名前</th>
                  <th>第一希望日</th>
                  <th>第二希望日</th>
                </tr>
              </thead>

              <tbody>
                {results.map(
                  ({
                    id,
                    name,
                    first_choice,
                    second_choice
                  }) => (
                    <tr key={id}>
                      <td>{name}</td>

                      <td>
                        {formatDate(first_choice)}
                      </td>

                      <td>
                        {formatDate(second_choice)}
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          )}

          {!loading && results.length === 0 && (
            <p style={{ marginTop: '10px' }}>
              該当する予約はありません。
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default ReservationByLocation;